import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

@observer(['companystates'])
export default class CompanyStates extends Component {

  constructor(props) {
    super(props)

    this.props.companystates.loadAllCompanyStates()
  }

  newCompanyState(row) {
    this.props.companystates.newCompanyState(row.name)
  }

  updateCompanyState(row, cellText, cellValue) {
    this.props.companystates.updateCompanyState(row.id, cellValue)
  }

  deleteCompanyState(id) {
    if (confirm('Are you sure you want to delete this Company State?')) {
      this.props.companystates.deleteCompanyState(id)
    }
  }

  formatActions(cell, row) {
    return <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteCompanyState(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
  }

  render() {
    const options = {
      onAddRow: this.newCompanyState.bind(this)
    }

    const companyStatesTable = (
      <BootstrapTable
          data={ this.props.companystates.data }
          striped={ true }
          hover={ true }
          pagination={ true }
          search={ true }
          exportCSV={ true }
          options={ options }
          insertRow={ true }
          bordered={ false }
          cellEdit={ { mode: 'click', blurToSave: false, afterSaveCell: this.updateCompanyState.bind(this) } } >
        <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
      </BootstrapTable>
    )

    return (
      <div>
        <Collapsible title="Company States" content={ companyStatesTable } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/companystates.js